// ==============================
// src/components/Consultar.js
// VERSIÓN REDISEÑADA - Pantallas de Perdido
// ==============================
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import * as bootstrap from "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap-icons/font/bootstrap-icons.css";

import rockyImg from "../assets/rocky.png";

if (typeof window !== "undefined") window.bootstrap = bootstrap;

const API_URL = process.env.REACT_APP_API_URL || "";

// =============================================
// DESIGN SYSTEM - Tokens de diseño
// =============================================
const DS = {
  colors: {
    // Fondos
    bgBase: '#FFFFFF',
    bgSurface: '#F9FAFB',
    // Bordes
    borderSoft: '#E5E7EB',
    // Texto
    textPrimary: '#1F2937',
    textSecondary: '#6B7280',
    // Acciones
    actionPrimary: '#65a30d',
    actionSecondary: '#6B7280',
    // Destacados
    highlightReward: '#FEF9C3',
    highlightRewardBorder: '#FDE68A',
    // Success
    successIcon: '#84cc16',
    // WhatsApp
    whatsapp: '#25D366',
  },
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '20px',
    xl: '28px',
  },
  radius: {
    sm: '8px',
    md: '12px',
    lg: '16px',
  },
  fonts: {
    family: 'Inter, system-ui, -apple-system, sans-serif',
  }
};

// eslint-disable-next-line no-unused-vars
const PLACEHOLDERS = {
  mascota: rockyImg,
  persona: "https://placehold.co/300x300/e2e8f0/64748b?text=Persona",
  llavero: "https://placehold.co/300x300/e2e8f0/64748b?text=Llavero",
  coleccionable: "https://placehold.co/300x300/fef3c7/92400e?text=🏆",
  default: "https://placehold.co/300x300/e2e8f0/64748b?text=Objeto"
};

const messages = {
  es: {
    noRegistro: "No se proporcionó ?registro=XYZ en la URL.",
    errCargarObjeto: "Error al cargar datos del objeto.",
    errRedCargando: "Ocurrió un error de red al cargar datos.",
    cargando: "Cargando...",
    codigoInactivo: "Este código no se ha activado.",
    altImagenObjeto: "Imagen del objeto",
    tituloContacto: "Información de Contacto",
    propietarioSinTel: "El propietario no tiene teléfono registrado.",
    noInfoPropietario: "No se encontró información del propietario.",
    recompensaOfrecida: "¡Recompensa Ofrecida!",
    elPropietario: "Propietario",
    visitarLemmon: "Visita LemmonTags.com",
    todosDerechos: "© 2025 LemmonTags. Todos los derechos reservados.",
    mascotaEncontrada: "mascota_encontrada_es",
    personaEncontrada: "persona_encontrada_es",
    llaveroEncontrado: "llavero_encontrado_es",
    // Mensaje educativo
    mensajeEducativo1: "Este objeto tiene un sistema de recuperación <strong>LemmonTags</strong>.",
    mensajeEducativo2: "Si lo encontraste perdido, puedes ayudar a devolverlo de forma <strong>segura y anónima</strong>.",
    mensajeEducativo3: "Tu acción solo toma un minuto.",
    // Modal de ubicación - objeto
    modalObjetoTitulo: "Has encontrado un objeto perdido",
    modalObjetoMensaje: "Este es {nombre} de {nombreProp}",
    modalObjetoEmocional: "{nombreProp} lo ha reportado como perdido. Al notificarle que lo encontraste, le evitarás un gran problema. ¡Gracias por ser una persona excepcional!",
    // Modal de ubicación - mascota
    modalMascotaTitulo: "Has encontrado una mascota perdida",
    modalMascotaMensaje: "Esta es {nombre}, la mascota de {nombreProp}",
    modalMascotaEmocional: "{nombreProp} está buscando desesperadamente a {nombre}. Al notificarle que lo encontraste, estarás reuniendo a una familia. ¡Eres increíble por ayudar!",
    // Modal de ubicación - llavero
    modalLlaveroTitulo: "Has encontrado un objeto perdido",
    modalLlaveroMensaje: "Este es {nombre} de {nombreProp}",
    modalLlaveroEmocional: "{nombreProp} lo ha reportado como perdido. Al notificarle que lo encontraste, le evitarás un gran problema. ¡Gracias por ser una persona excepcional!",
    // Recompensa
    recompensaOfreciendo: "{nombreProp} está ofreciendo una gratificación",
    recompensaPorDevolver: "Por tu generosa acción de devolverlo",
    recompensaPorDevolverla: "Por tu generosa acción de devolverla",
    // Compartir ubicación
    compartirUbicPregunta: "¿Compartir tu ubicación con {nombreProp}?",
    compartirUbicHint: "Esto ayudará a coordinar la devolución más rápido",
    compartirUbicSi: "Continuar con ubicación",
    compartirUbicNo: "Continuar sin ubicación",
    compartirUbicNextHint: "ℹ️ En el siguiente paso podrás dejar un mensaje de contacto",
    // Modal de mensaje
    dejarMensajeTitulo: "Dejar un mensaje para {nombreProp}",
    dejarMensajeHint: "Describe dónde dejaste el objeto o cómo pueden contactarte.",
    tuMensaje: "Tu mensaje",
    tuMensajeRequerido: "Por favor escribe un mensaje para que {nombreProp} pueda encontrar su objeto.",
    tuTelefono: "Tu teléfono (opcional)",
    privacidadProtegida: "Tu privacidad está protegida:",
    privacidadMensaje: "Esta información no será almacenada, solo se enviará a {nombreProp}.",
    enviarMensaje: "Enviar mensaje",
    cancelar: "Cancelar",
    // Modal de gracias
    graciasTitle: "¡Muchas Gracias!",
    graciasMessage: "{nombreProp} recibirá tu mensaje y se comunicará contigo muy pronto.",
    graciasComunidad: "Eres parte de una comunidad increíble",
    graciasHonestidad: "Tu honestidad marca la diferencia",
    entendido: "Entendido",
    // Contacto
    contactarPor: "Contactar a {nombreProp}",
    contactarWhatsApp: "Contactar por WhatsApp",
    telefono: "Teléfono",
    noPuedesLlamar: "¿No puedes llamar?",
    contactar: "Contactar",
    dejarUnMensaje: "Dejar un mensaje",
    // Página de consulta
    codigoNoActivado: "Este código QR aún no ha sido vinculado.",
    tagVencido: "Este tag ha vencido",
    tagVencidoMensaje: "El plan de este tag ha expirado. Si eres el propietario, contacta a soporte para reactivarlo.",
    verificarAutenticidad: "Verificar autenticidad",
    // Fallback
    perteneceA: "Este {tipo} pertenece a {nombreProp}.",
    siLoEncontraste: "Si lo encontraste, contáctalo para coordinar la devolución.",
    raza: "Raza",
    especie: "Especie",
    senas: "Señas",
    alergias: "Alergias",
    infoImportante: "Información importante",
    ofrece: "{nombreProp} ofrece"
  },
  en: {
    noRegistro: "No ?registro=XYZ provided in the URL.",
    errCargarObjeto: "Error loading object data.",
    errRedCargando: "A network error occurred while loading data.",
    cargando: "Loading...",
    codigoInactivo: "This code has not been activated.",
    altImagenObjeto: "Object image",
    tituloContacto: "Contact Information",
    propietarioSinTel: "The owner does not have a registered phone number.",
    noInfoPropietario: "No owner information found.",
    recompensaOfrecida: "Reward Offered!",
    elPropietario: "Owner",
    visitarLemmon: "Visit LemmonTags.com",
    todosDerechos: "© 2025 LemmonTags. All rights reserved.",
    mascotaEncontrada: "mascota_encontrada_en",
    personaEncontrada: "persona_encontrada_en",
    llaveroEncontrado: "llavero_encontrado_en",
    // Educational message
    mensajeEducativo1: "This item has a <strong>LemmonTags</strong> recovery system.",
    mensajeEducativo2: "If you found it lost, you can help return it <strong>safely and anonymously</strong>.",
    mensajeEducativo3: "Your action only takes a minute.",
    // Location modal - object
    modalObjetoTitulo: "You found a lost item",
    modalObjetoMensaje: "This is {nombre} from {nombreProp}",
    modalObjetoEmocional: "{nombreProp} reported it as lost. By notifying them you found it, you'll save them a big problem. Thank you for being an exceptional person!",
    // Location modal - pet
    modalMascotaTitulo: "You found a lost pet",
    modalMascotaMensaje: "This is {nombre}, {nombreProp}'s pet",
    modalMascotaEmocional: "{nombreProp} is desperately looking for {nombre}. By notifying them you found it, you'll be reuniting a family. You're amazing for helping!",
    // Location modal - keychain
    modalLlaveroTitulo: "You found a lost item",
    modalLlaveroMensaje: "This is {nombre} from {nombreProp}",
    modalLlaveroEmocional: "{nombreProp} reported it as lost. By notifying them you found it, you'll save them a big problem. Thank you for being an exceptional person!",
    // Reward
    recompensaOfreciendo: "{nombreProp} is offering a reward",
    recompensaPorDevolver: "For your generous act of returning it",
    recompensaPorDevolverla: "For your generous act of returning her",
    // Share location
    compartirUbicPregunta: "Share your location with {nombreProp}?",
    compartirUbicHint: "This will help coordinate the return faster",
    compartirUbicSi: "Continue with location",
    compartirUbicNo: "Continue without location",
    compartirUbicNextHint: "ℹ️ In the next step you can leave a contact message",
    // Message modal
    dejarMensajeTitulo: "Leave a message for {nombreProp}",
    dejarMensajeHint: "Describe where you left the item or how they can contact you.",
    tuMensaje: "Your message",
    tuMensajeRequerido: "Please write a message so {nombreProp} can find their item.",
    tuTelefono: "Your phone (optional)",
    privacidadProtegida: "Your privacy is protected:",
    privacidadMensaje: "This information won't be stored, it will only be sent to {nombreProp}.",
    enviarMensaje: "Send message",
    cancelar: "Cancel",
    // Thanks modal
    graciasTitle: "Thank You So Much!",
    graciasMessage: "{nombreProp} will receive your message and will contact you soon.",
    graciasComunidad: "You're part of an amazing community",
    graciasHonestidad: "Your honesty makes the difference",
    entendido: "Got it",
    // Contact
    contactarPor: "Contact {nombreProp}",
    contactarWhatsApp: "Contact via WhatsApp",
    telefono: "Phone",
    noPuedesLlamar: "Can't call?",
    contactar: "Contact",
    dejarUnMensaje: "Leave a message",
    // Consultation page
    codigoNoActivado: "This QR code has not been linked yet.",
    tagVencido: "This tag has expired",
    tagVencidoMensaje: "The plan for this tag has expired. If you are the owner, contact support to reactivate it.",
    verificarAutenticidad: "Verify authenticity",
    // Fallback
    perteneceA: "This {tipo} belongs to {nombreProp}.",
    siLoEncontraste: "If you found it, contact them to coordinate the return.",
    raza: "Breed",
    especie: "Species",
    senas: "Markings",
    alergias: "Allergies",
    infoImportante: "Important information",
    ofrece: "{nombreProp} offers"
  },
};

// Helper function with variable interpolation
function t(lang, key, vars = {}) {
  let text = messages[lang]?.[key] || messages['es']?.[key] || key;
  Object.keys(vars).forEach(v => {
    text = text.replace(new RegExp(`\\{${v}\\}`, 'g'), vars[v]);
  });
  return text;
}

function getNombreSegunTipo(obj) {
  return obj.nombre || 
         (obj.tipo === 'mascota' ? 'Mascota' :
          obj.tipo === 'persona' ? 'Persona' :
          obj.tipo === 'llavero' ? 'Llavero' : 'Objeto');
}

// Extraer solo primer nombre (privacidad)
function getPrimerNombre(nombreCompleto) {
  if (!nombreCompleto) return "el propietario";
  return nombreCompleto.trim().split(' ')[0];
}

// Ajustar tamaño según longitud
// eslint-disable-next-line no-unused-vars
function getTamanoTitulo(texto) {
  if (texto.length > 30) {
    return 'var(--font-size-lg)';
  }
  if (texto.length > 20) {
    return 'var(--font-size-xl)';
  }
  return 'var(--font-size-2xl)';
}

// Mensajes personalizados
function getMensajePersonalizado(objeto, propietario, lang) {
  const nombre = getNombreSegunTipo(objeto);
  const nombreProp = getPrimerNombre(propietario?.nombre);
  
  if (objeto.tipo === 'mascota') {
    if (objeto.extraviado) {
      return {
        titulo: `${nombre} está perdido`,
        mensaje: `Si lo encontraste, contacta a ${nombreProp}.`,
        emoji: "🐕",
        color: "#ef4444"
      };
    } else {
      return {
        titulo: `Hola, soy ${nombre}`,
        mensaje: `Mi dueño es ${nombreProp}. Si me encuentras perdido, contáctalo.`,
        emoji: "🐾",
        color: "#334155"
      };
    }
  } else if (objeto.tipo === 'llavero') {
    if (objeto.extraviado) {
      return {
        titulo: `${nombre} extraviado`,
        mensaje: `Pertenece a ${nombreProp}. Por favor devuélvelo.`,
        emoji: "🔑",
        color: "#f59e0b"
      };
    } else {
      return {
        titulo: nombre,
        mensaje: `Pertenece a ${nombreProp}.`,
        emoji: "🔑",
        color: "#334155"
      };
    }
  }
  
  return {
    titulo: nombre,
    mensaje: `Pertenece a ${nombreProp}.`,
    emoji: "📦",
    color: "#334155"
  };
}

export default function Consultar() {
  const [searchParams] = useSearchParams();
  const docId = searchParams.get("registro");

  const [cargando, setCargando] = useState(true);
  const [error, setError] = useState("");
  const [objeto, setObjeto] = useState(null);
  const [propietario, setPropietario] = useState(null);
  const [contenidoHTML, setContenidoHTML] = useState("");
  const [correoEnviado, setCorreoEnviado] = useState(false);
  const [noActivado, setNoActivado] = useState(false);
  const [tagVencido, setTagVencido] = useState(false);
  const [mensajePublico, setMensajePublico] = useState("");
  const [instrucciones, setInstrucciones] = useState("");
  const [folio, setFolio] = useState("");

  // =============================================
  // PANTALLA 1: Modal de ubicación rediseñado
  // Diseño: Friendly Profesional, tema claro
  // =============================================
  const mostrarModalUbicacion = (lang, objetoData, propietarioData) => {
  return new Promise((resolve) => {
    const nombre = getNombreSegunTipo(objetoData);
    const nombreProp = getPrimerNombre(propietarioData?.nombre) || "el dueño";
    const hayRecompensa = objetoData.ofrecerRecompensa === true && objetoData.recompensa && String(objetoData.recompensa).trim() !== '';
    const esMascota = objetoData.tipo === 'mascota';

    // Textos según tipo
    const estadoTexto = esMascota
      ? (lang === 'en' ? 'Pet found' : 'Mascota encontrada')
      : (lang === 'en' ? 'Item found' : 'Objeto encontrado');

    const identidadTexto = esMascota
      ? (lang === 'en'
          ? `This is <strong>${nombre}</strong>, ${nombreProp}'s pet`
          : `Esta es <strong>${nombre}</strong>, la mascota de ${nombreProp}`)
      : (lang === 'en'
          ? `<strong>${nombre}</strong><br/>Belongs to ${nombreProp}`
          : `<strong>${nombre}</strong><br/>Pertenece a ${nombreProp}`);

    const mensajeEmpatico = esMascota
      ? (lang === 'en'
          ? `${nombreProp} is desperately looking for ${nombre}. By notifying them, you'll be reuniting a family. You're amazing for helping!`
          : `${nombreProp} está buscando desesperadamente a ${nombre}. Al notificarle que lo encontraste, estarás reuniendo a una familia. ¡Eres increíble por ayudar!`)
      : (lang === 'en'
          ? `${nombreProp} lost this item. Your help will make a difference.`
          : `${nombreProp} perdió este objeto. Tu ayuda hará la diferencia.`);

    const recompensaTitulo = lang === 'en'
      ? `${nombreProp} offers a reward`
      : `${nombreProp} ofrece una recompensa`;

    const recompensaSubtexto = esMascota
      ? (lang === 'en' ? 'For your generous act of returning her' : 'Por tu generosa acción de devolverla')
      : (lang === 'en' ? 'For your generous act of returning it' : 'Por tu generosa acción de devolverlo');

    const preguntaUbicacion = lang === 'en'
      ? `Share your location with ${nombreProp}?`
      : `¿Compartir tu ubicación con ${nombreProp}?`;

    const ubicacionHint = lang === 'en'
      ? 'This will help coordinate the return faster'
      : 'Esto ayudará a coordinar la devolución más rápido';

    const btnCompartir = lang === 'en' ? 'Share location' : 'Compartir ubicación';
    const btnSinUbicacion = lang === 'en' ? 'Continue without location' : 'Continuar sin ubicación';
    const siguientePaso = lang === 'en'
      ? `Next: Contact ${nombreProp}`
      : `Siguiente: Contactar a ${nombreProp}`;

    const modalHTML = `
      <div class="modal fade" id="locationModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static">
        <div class="modal-dialog modal-dialog-centered" style="margin: 16px; max-width: 420px;">
          <div class="modal-content" style="
            border-radius: ${DS.radius.lg};
            overflow: hidden;
            border: 1px solid ${DS.colors.borderSoft};
            background: ${DS.colors.bgBase};
            font-family: ${DS.fonts.family};
          ">

            <!-- Indicador de pasos -->
            <div style="
              display: flex;
              justify-content: center;
              gap: 8px;
              padding: 16px 16px 0;
            ">
              <span style="
                width: 8px; height: 8px;
                border-radius: 50%;
                background: ${DS.colors.successIcon};
              "></span>
              <span style="
                width: 8px; height: 8px;
                border-radius: 50%;
                background: ${DS.colors.borderSoft};
              "></span>
            </div>

            <!-- Estado: Encontrado -->
            <div style="
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 8px;
              padding: 16px;
            ">
              <span style="
                color: ${DS.colors.successIcon};
                font-size: 20px;
              ">✓</span>
              <span style="
                color: ${DS.colors.textPrimary};
                font-size: 16px;
                font-weight: 600;
              ">${estadoTexto}</span>
            </div>

            <!-- Identidad -->
            <div style="
              text-align: center;
              padding: 0 20px 16px;
            ">
              <p style="
                color: ${DS.colors.textPrimary};
                font-size: 18px;
                font-weight: 500;
                margin: 0;
                line-height: 1.4;
              ">${identidadTexto}</p>
            </div>

            <!-- Mensaje empático -->
            <div style="
              padding: 0 20px 20px;
              text-align: center;
            ">
              <p style="
                color: ${DS.colors.textSecondary};
                font-size: 14px;
                line-height: 1.5;
                margin: 0;
              ">${mensajeEmpatico}</p>
            </div>

            ${hayRecompensa ? `
            <!-- Bloque de recompensa -->
            <div style="
              margin: 0 16px 20px;
              padding: 16px;
              background: ${DS.colors.highlightReward};
              border: 1px solid ${DS.colors.highlightRewardBorder};
              border-radius: ${DS.radius.md};
            ">
              <p style="
                color: ${DS.colors.textPrimary};
                font-size: 14px;
                font-weight: 600;
                margin: 0 0 8px;
                text-align: center;
              ">${recompensaTitulo}</p>
              <p style="
                color: ${DS.colors.textPrimary};
                font-size: 28px;
                font-weight: 700;
                margin: 0 0 4px;
                text-align: center;
              ">$${objetoData.recompensa} MXN</p>
              <p style="
                color: ${DS.colors.textSecondary};
                font-size: 12px;
                margin: 0;
                text-align: center;
              ">${recompensaSubtexto}</p>
            </div>
            ` : ''}

            ${objetoData.tipo === 'mascota' && (objetoData.senasParticulares || objetoData.alergias) ? `
            <!-- Información importante -->
            <div style="
              margin: 0 16px 20px;
              padding: 12px 16px;
              background: ${DS.colors.bgSurface};
              border: 1px solid ${DS.colors.borderSoft};
              border-radius: ${DS.radius.md};
            ">
              <div style="
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 8px;
              ">
                <span style="color: ${DS.colors.textSecondary};">ℹ️</span>
                <span style="
                  color: ${DS.colors.textPrimary};
                  font-size: 13px;
                  font-weight: 600;
                ">${lang === 'en' ? 'Important information' : 'Información importante'}</span>
              </div>
              ${objetoData.senasParticulares ? `
              <p style="
                color: ${DS.colors.textSecondary};
                font-size: 13px;
                margin: 0 0 4px;
                line-height: 1.4;
              "><strong>${lang === 'en' ? 'Markings:' : 'Señas:'}</strong> ${objetoData.senasParticulares}</p>
              ` : ''}
              ${objetoData.alergias ? `
              <p style="
                color: ${DS.colors.textSecondary};
                font-size: 13px;
                margin: 0;
                line-height: 1.4;
              "><strong>${lang === 'en' ? 'Allergies:' : 'Alergias:'}</strong> ${objetoData.alergias}</p>
              ` : ''}
            </div>
            ` : ''}

            <!-- Pregunta de ubicación -->
            <div style="
              text-align: center;
              padding: 0 20px 8px;
            ">
              <p style="
                color: ${DS.colors.textPrimary};
                font-size: 15px;
                font-weight: 600;
                margin: 0 0 4px;
              ">${preguntaUbicacion}</p>
              <p style="
                color: ${DS.colors.textSecondary};
                font-size: 13px;
                margin: 0;
              ">${ubicacionHint}</p>
            </div>

            <!-- Botones -->
            <div style="padding: 16px 16px 12px;">
              <!-- Botón primario -->
              <button
                type="button"
                id="shareLocation"
                style="
                  width: 100%;
                  padding: 14px 20px;
                  background: ${DS.colors.actionPrimary};
                  color: white;
                  border: none;
                  border-radius: ${DS.radius.md};
                  font-size: 15px;
                  font-weight: 600;
                  cursor: pointer;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 8px;
                  margin-bottom: 10px;
                  transition: opacity 0.2s;
                "
                onmouseover="this.style.opacity='0.9'"
                onmouseout="this.style.opacity='1'"
              >
                ${btnCompartir} →
              </button>

              <!-- Botón secundario -->
              <button
                type="button"
                id="noLocation"
                style="
                  width: 100%;
                  padding: 12px 20px;
                  background: transparent;
                  color: ${DS.colors.actionSecondary};
                  border: 1px solid ${DS.colors.borderSoft};
                  border-radius: ${DS.radius.md};
                  font-size: 14px;
                  font-weight: 500;
                  cursor: pointer;
                  transition: background 0.2s;
                "
                onmouseover="this.style.background='${DS.colors.bgSurface}'"
                onmouseout="this.style.background='transparent'"
              >
                ${btnSinUbicacion}
              </button>
            </div>

            <!-- Texto anticipatorio -->
            <div style="
              text-align: center;
              padding: 0 16px 16px;
            ">
              <p style="
                color: ${DS.colors.textSecondary};
                font-size: 12px;
                margin: 0;
              ">${siguientePaso}</p>
            </div>

            <!-- Branding -->
            <div style="
              text-align: center;
              padding: 12px;
              border-top: 1px solid ${DS.colors.borderSoft};
            ">
              <span style="
                color: #D1D5DB;
                font-size: 12px;
                font-weight: 500;
              ">LemmonTags</span>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);

    if (typeof window.bootstrap !== "undefined") {
      const el = document.getElementById("locationModal");
      const modal = new window.bootstrap.Modal(el);

      document.getElementById("shareLocation").onclick = () => {
        modal.hide();
        el.remove();
        resolve(true);
      };

      document.getElementById("noLocation").onclick = () => {
        modal.hide();
        el.remove();
        resolve(false);
      };

      modal.show();
    } else {
      const el = document.getElementById("locationModal");
      if (el) el.remove();
      resolve(false);
    }
  });
};

  // ✅ MODAL MODIFICADO: Mensaje obligatorio, teléfono opcional
  const mostrarModalAviso = (lang, objetoData, propietarioData) => {
  return new Promise((resolve) => {
    const nombreProp = getPrimerNombre(propietarioData?.nombre) || "el propietario";
    
    const modalHTML = `
      <div class="modal fade" id="avisoModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="margin: var(--space-3);">
          <div class="modal-content" style="border-radius: var(--radius-2xl); overflow: hidden; border: none;">
            
            <!-- Header -->
            <div style="
              background: linear-gradient(135deg, #f8d775 0%, #e5c162 100%);
              padding: var(--space-4);
              text-align: center;
            ">
              <div style="
                font-size: 48px;
                margin-bottom: var(--space-2);
                filter: drop-shadow(0 4px 8px rgba(0,0,0,0.1));
              ">
                📝
              </div>
              <h5 style="
                color: var(--gray-900);
                font-size: var(--font-size-lg);
                font-weight: var(--font-weight-bold);
                margin: 0;
              ">
                ${t(lang, 'dejarMensajeTitulo', { nombreProp })}
              </h5>
            </div>

            <!-- Body -->
            <div style="padding: var(--space-4);">

              <div style="
                text-align: center;
                margin-bottom: var(--space-3);
              ">
                <p style="
                  font-size: var(--font-size-sm);
                  color: var(--gray-700);
                  line-height: var(--line-height-relaxed);
                  margin-bottom: 0;
                ">
                  ${t(lang, 'dejarMensajeHint')}
                </p>
              </div>

              <!-- Formulario -->
              <div style="
                background: var(--gray-50);
                padding: var(--space-3);
                border-radius: var(--radius-lg);
                margin-bottom: var(--space-3);
              ">
                <!-- Campo de mensaje OBLIGATORIO -->
                <label for="finderMensaje" style="
                  display: block;
                  font-size: var(--font-size-sm);
                  font-weight: var(--font-weight-semibold);
                  color: var(--gray-900);
                  margin-bottom: var(--space-2);
                ">
                  ${t(lang, 'tuMensaje')} <span style="color: #ef4444;">*</span>
                </label>

                <textarea
                  id="finderMensaje"
                  class="form-control"
                  placeholder="${lang === 'en' ? 'E.g.: I left it at the hotel reception, ask for John...' : 'Ej: Lo dejé en la recepción del hotel, preguntar por Juan...'}"
                  rows="3"
                  style="
                    font-size: var(--font-size-sm);
                    padding: var(--space-2);
                    border-radius: var(--radius-md);
                    border: 2px solid var(--gray-300);
                    margin-bottom: var(--space-3);
                    resize: none;
                  "
                ></textarea>

                <p id="mensajeError" style="
                  font-size: var(--font-size-xs);
                  color: #ef4444;
                  margin-bottom: var(--space-2);
                  display: none;
                ">
                  <i class="bi bi-exclamation-circle"></i>
                  ${t(lang, 'tuMensajeRequerido', { nombreProp })}
                </p>
                
                <label for="finderTelefono" style="
                  display: block;
                  font-size: var(--font-size-sm);
                  font-weight: var(--font-weight-semibold);
                  color: var(--gray-900);
                  margin-bottom: var(--space-2);
                ">
                  ${t(lang, 'tuTelefono')}
                </label>

                <input
                  type="tel"
                  id="finderTelefono"
                  class="form-control"
                  placeholder="${lang === 'en' ? 'E.g.: 5551234567' : 'Ej: 2291234567'}"
                  maxlength="10"
                  style="
                    font-size: var(--font-size-sm);
                    padding: var(--space-2);
                    border-radius: var(--radius-md);
                    border: 2px solid var(--gray-300);
                    margin-bottom: var(--space-2);
                  "
                />

                <!-- Mensaje de privacidad -->
                <div style="
                  background: white;
                  padding: var(--space-2);
                  border-radius: var(--radius-md);
                  border: 1px solid #10b981;
                  display: flex;
                  align-items: flex-start;
                  gap: var(--space-2);
                ">
                  <i class="bi bi-shield-check" style="
                    color: #10b981;
                    font-size: 16px;
                    margin-top: 2px;
                    flex-shrink: 0;
                  "></i>
                  <p style="
                    font-size: var(--font-size-xs);
                    color: #059669;
                    margin: 0;
                    line-height: var(--line-height-relaxed);
                    font-weight: var(--font-weight-medium);
                  ">
                    <strong>${t(lang, 'privacidadProtegida')}</strong> ${t(lang, 'privacidadMensaje', { nombreProp })}
                  </p>
                </div>
              </div>
            </div>
            
            <!-- Footer -->
            <div style="
              padding: var(--space-3);
              background: var(--gray-50);
              display: flex;
              flex-direction: column;
              gap: var(--space-2);
            ">
              <button 
                type="button" 
                class="btn btn-primary w-100" 
                id="enviarAviso"
                style="
                  font-size: var(--font-size-base);
                  font-weight: var(--font-weight-bold);
                  padding: var(--space-3);
                  border-radius: var(--radius-lg);
                  background: linear-gradient(135deg, #f8d775 0%, #e5c162 100%);
                  border: none;
                  color: var(--gray-900);
                  box-shadow: 0 4px 12px rgba(248, 215, 117, 0.3);
                  transition: all 0.3s ease;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: var(--space-2);
                "
              >
                <i class="bi bi-send-fill"></i>
                ${t(lang, 'enviarMensaje')}
              </button>

              <button
                type="button"
                class="btn btn-secondary w-100"
                id="cancelarAviso"
                style="
                  font-size: var(--font-size-sm);
                  padding: var(--space-2);
                  border-radius: var(--radius-md);
                  background: var(--gray-300);
                  border: none;
                  color: var(--gray-700);
                  font-weight: var(--font-weight-medium);
                "
              >
                ${t(lang, 'cancelar')}
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    document.body.insertAdjacentHTML("beforeend", modalHTML);

    if (typeof window.bootstrap !== "undefined") {
      const el = document.getElementById("avisoModal");
      const modal = new window.bootstrap.Modal(el);

      const btnEnviar = document.getElementById("enviarAviso");
      btnEnviar.addEventListener("mouseenter", () => {
        btnEnviar.style.transform = "translateY(-2px)";
        btnEnviar.style.boxShadow = "0 6px 16px rgba(248, 215, 117, 0.4)";
      });
      btnEnviar.addEventListener("mouseleave", () => {
        btnEnviar.style.transform = "translateY(0)";
        btnEnviar.style.boxShadow = "0 4px 12px rgba(248, 215, 117, 0.3)";
      });

      btnEnviar.onclick = () => {
        const mensaje = document.getElementById("finderMensaje").value.trim();
        const telefono = document.getElementById("finderTelefono").value.trim();
        const errorEl = document.getElementById("mensajeError");
        
        // ✅ Validar que el mensaje no esté vacío
        if (!mensaje) {
          errorEl.style.display = "block";
          document.getElementById("finderMensaje").style.borderColor = "#ef4444";
          return;
        }
        
        modal.hide();
        el.remove();
        resolve({ mensaje, telefono }); // Retorna objeto con mensaje y teléfono
      };

      document.getElementById("cancelarAviso").onclick = () => {
        modal.hide();
        el.remove();
        resolve(null); // null = cancelado
      };
      
      // Limpiar error al escribir
      document.getElementById("finderMensaje").addEventListener("input", () => {
        document.getElementById("mensajeError").style.display = "none";
        document.getElementById("finderMensaje").style.borderColor = "var(--gray-300)";
      });

      modal.show();
    } else {
      const el = document.getElementById("avisoModal");
      if (el) el.remove();
      resolve(null);
    }
  });
};

const mostrarConfirmacion = (mensaje, esExito = true) => {
  const icono = esExito ? '✓' : '✕';
  const color = esExito ? '#10b981' : '#ef4444';
  
  const toastHTML = `
    <div id="confirmacionToast" style="
      position: fixed;
      top: 70px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 9999;
      background: white;
      padding: var(--space-3) var(--space-4);
      border-radius: var(--radius-lg);
      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
      display: flex;
      align-items: center;
      gap: var(--space-2);
      animation: slideDown 0.3s ease-out;
      max-width: 90%;
    ">
      <div style="
        width: 32px;
        height: 32px;
        background: ${color};
        border-radius: var(--radius-full);
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-size: 18px;
        font-weight: bold;
      ">
        ${icono}
      </div>
      <span style="
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-semibold);
        color: var(--gray-900);
      ">
        ${mensaje}
      </span>
    </div>
    <style>
      @keyframes slideDown {
        from {
          opacity: 0;
          transform: translateX(-50%) translateY(-20px);
        }
        to {
          opacity: 1;
          transform: translateX(-50%) translateY(0);
        }
      }
    </style>
  `;
  
  document.body.insertAdjacentHTML("beforeend", toastHTML);
  
    setTimeout(() => {
      const toast = document.getElementById("confirmacionToast");
      if (toast) {
        toast.style.animation = "slideDown 0.3s ease-out reverse";
        setTimeout(() => toast.remove(), 300);
      }
    }, 3000);
  };

  // eslint-disable-next-line no-unused-vars
  async function enviarCorreoAlPropietario(templateId, context) {
    // El correo del dueño NO está disponible en el cliente (el backend lo
    // enmascara por privacidad), por lo que el envío del email se resuelve en
    // el servidor mediante POST /api/objetos/publico/:docId/contacto, que usa
    // la cola de emails. El backend elige la plantilla según el tipo de objeto.
    const mensaje = (context?.mensajeFinder || "").trim();

    // Sin mensaje no hay nada que enviar (p. ej. ping automático de escaneo).
    if (!mensaje) {
      return true;
    }

    try {
      const resp = await fetch(
        `${API_URL}/api/objetos/publico/${encodeURIComponent(docId)}/contacto`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            mensaje,
            telefono: context?.telefonoFinder || "",
            googleMapsLink: context?.googleMapsLink || "",
          }),
        }
      );

      const data = await resp.json().catch(() => ({}));
      if (!resp.ok) {
        // 429 = el dueño ya fue notificado antes (anti-spam): tratar como éxito
        if (resp.status === 429) {
          return true;
        }
        console.error("❌ Error al notificar al propietario:", data);
        return false;
      }

      return true;
    } catch (err) {
      console.error("❌ Error en enviarCorreoAlPropietario =>", err);
      return false;
    }
  }

  useEffect(() => {
    const fetchDataAndRender = async () => {
      if (!docId) {
        setError(t("es", "noRegistro"));
        setCargando(false);
        return;
      }

      setCargando(true);
      try {
        const respObj = await fetch(
          `${API_URL}/api/objetos/publico/${encodeURIComponent(docId)}`
        );

        if (!respObj.ok) {
          throw new Error(t("es", "errCargarObjeto"));
        }

        const dataObj = await respObj.json();

        // Handle noActivado response (tag not activated)
        if (dataObj.noActivado) {
          setNoActivado(true);
          setMensajePublico(dataObj.mensajePublico || "");
          setInstrucciones(dataObj.instrucciones || "");
          setFolio(dataObj.folio || "");
          setCargando(false);
          return;
        }

        // Handle tagVencido response (tag expired)
        if (dataObj.tagVencido) {
          setTagVencido(true);
          setMensajePublico(dataObj.mensajePublico || "");
          setInstrucciones(dataObj.instrucciones || "");
          setFolio(dataObj.folio || "");
          setCargando(false);
          return;
        }

        if (!dataObj.data) {
          setError(t("es", "errCargarObjeto"));
          setCargando(false);
          return;
        }

        const objetoData = dataObj.data;
        const propietarioData = dataObj.data?.propietario || null;

        setObjeto(objetoData);
        setPropietario(propietarioData);

        // Priorizar idioma del objeto (Premium), luego del propietario, luego español
        const lang = objetoData?.idiomaRecuperacion || propietarioData?.idiomaPreferido || "es";
        const estado = objetoData.extraviado ? "perdido" : "normal";
        // Mapear llavero y coleccionable a plantilla 'objeto'
        const tipoPlantilla = ['llavero', 'coleccionable'].includes(objetoData.tipo) ? 'objeto' : objetoData.tipo;
        const templateId = `${tipoPlantilla}_${estado}_${lang}`;

        const context = {
          nombreMascota: objetoData.nombre || '',  
          nombreObjeto: objetoData.nombre || '',
          nombre: objetoData.nombre || '',
          nombrePropietario: getPrimerNombre(propietarioData?.nombre) || "",
          tipoObjeto: objetoData.tipo
        };

        const respRender = await fetch(`${API_URL}/api/renderTemplate`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ templateId, context }),
        });

        if (respRender.ok) {
          const dataRender = await respRender.json();
          setContenidoHTML(dataRender.contenido || "");
        }
      } catch (err) {
        console.error("Error en el flujo de consulta =>", err);
        setError(err.message || t("es", "errRedCargando"));
      } finally {
        setCargando(false);
      }
    };

    fetchDataAndRender();
  }, [docId]);

  useEffect(() => {
    if (!cargando && !error && objeto && propietario && objeto.extraviado && !correoEnviado) {
    const lang = objeto?.idiomaRecuperacion || propietario?.idiomaPreferido || "es";
      
      setCorreoEnviado(true);
      
      let templateKey = "";
      if (objeto.tipo === "mascota") {
        templateKey = "mascotaEncontrada";
      } else if (objeto.tipo === "llavero") {
        templateKey = "llaveroEncontrado";
      }
      
      mostrarModalUbicacion(lang, objeto, propietario).then((deseaUbicacion) => {
        const notificarEncontrado = async (lat, lng) => {
          let googleMapsLink = "";
          
          if (lat && lng && deseaUbicacion) {
            googleMapsLink = `https://www.google.com/maps?q=${lat},${lng}`;
          }

          const context = {
            nombreMascota: getNombreSegunTipo(objeto),
            nombreObjeto: getNombreSegunTipo(objeto), 
            nombre: getNombreSegunTipo(objeto),
            nombrePropietario: getPrimerNombre(propietario.nombre) || "Propietario",
            tipoObjeto: objeto.tipo,
            googleMapsLink,
          };

          await enviarCorreoAlPropietario(t(lang, templateKey), context);
        };

        if (deseaUbicacion) {
          if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(
              async (position) => {
                const { latitude, longitude } = position.coords;
                await notificarEncontrado(latitude, longitude);
              },
              async (err) => {
                console.warn("No se obtuvo ubicación", err);
                await notificarEncontrado();
              },
              { enableHighAccuracy: true, timeout: 15000 }
            );
          } else {
            notificarEncontrado();
          }
        } else {
          notificarEncontrado();
        }
      });
    }
  }, [cargando, error, objeto, propietario, correoEnviado]);

  const getWhatsAppText = () => {
    const nombre = getNombreSegunTipo(objeto);
    const nombreProp = getPrimerNombre(propietario?.nombre) || "";
    
    if (objeto.tipo === 'mascota') {
      return `Hola ${nombreProp}, encontré a ${nombre} con tu LemmonTag.`;
    } else {
      return `Hola ${nombreProp}, encontré tu ${nombre} con tu LemmonTag.`;
    }
  };

  if (cargando) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #FFF9E6 0%, #FFFFFF 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "var(--space-4)"
      }}>
        <div style={{ textAlign: "center" }}>
          <div style={{
            margin: "0 auto var(--space-3)",
            fontSize: "var(--font-size-lg)",
            fontWeight: "var(--font-weight-bold)",
            background: "linear-gradient(135deg, #f8d775 0%, #e5c162 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            animation: "pulse 2s ease-in-out infinite"
          }}>
            LemmonTags
          </div>
          <div className="spinner-border" 
               role="status"
               style={{ 
                 width: "2.5rem", 
                 height: "2.5rem",
                 color: "#f8d775",
                 marginBottom: "var(--space-2)"
               }}>
            <span className="visually-hidden">{t("es", "cargando")}</span>
          </div>
          <p style={{
            fontSize: 'var(--font-size-base)',
            color: 'var(--gray-700)',
            fontWeight: 'var(--font-weight-medium)'
          }}>
            {t("es", "cargando")}
          </p>
        </div>
        
        <style>{`
          @keyframes pulse {
            0%, 100% { transform: scale(1); }
            50% { transform: scale(1.05); }
          }
        `}</style>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #FFF9E6 0%, #FFFFFF 100%)",
        padding: "var(--space-4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div className="alert alert-danger"
             style={{
               borderRadius: 'var(--radius-xl)',
               padding: 'var(--space-4)',
               maxWidth: "500px",
               width: "100%",
               border: "none",
               boxShadow: "0 10px 40px rgba(220, 53, 69, 0.15)"
             }}>
          <div style={{ marginBottom: "var(--space-2)", textAlign: "center" }}>
            <i className="bi bi-exclamation-triangle" 
               style={{ fontSize: "40px", color: "#dc3545" }}></i>
          </div>
          <p style={{ 
            textAlign: "center", 
            marginBottom: 0,
            fontSize: "var(--font-size-sm)"
          }}>
            {error}
          </p>
        </div>
      </div>
    );
  }

  // Handle noActivado state (tag not activated)
  if (noActivado) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #FFF9E6 0%, #FFFFFF 100%)",
        padding: "var(--space-4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(20px)",
          borderRadius: "var(--radius-2xl)",
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.08)",
          overflow: "hidden",
          maxWidth: "500px",
          padding: "var(--space-5)",
          textAlign: "center"
        }}>
          <div style={{
            width: "72px",
            height: "72px",
            margin: "0 auto var(--space-3)",
            background: "linear-gradient(135deg, #06b6d4 0%, #0284c7 100%)",
            borderRadius: "var(--radius-full)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 8px 24px rgba(6, 182, 212, 0.25)"
          }}>
            <i className="bi bi-info-circle"
               style={{ fontSize: '40px', color: 'white' }}></i>
          </div>
          <h5 style={{
            fontSize: 'var(--font-size-xl)',
            fontWeight: 'var(--font-weight-bold)',
            marginBottom: 'var(--space-2)',
            color: 'var(--gray-900)',
            letterSpacing: '-0.02em'
          }}>
            {t("es", "codigoInactivo")}
          </h5>
          <p style={{
            fontSize: 'var(--font-size-sm)',
            color: 'var(--gray-600)',
            marginBottom: 'var(--space-3)',
            lineHeight: 'var(--line-height-relaxed)'
          }}>
            {mensajePublico || t("es", "codigoNoActivado")}
          </p>
          {instrucciones && (
            <p style={{
              fontSize: 'var(--font-size-xs)',
              color: 'var(--gray-500)',
              marginBottom: 0,
              lineHeight: 'var(--line-height-relaxed)',
              fontStyle: 'italic'
            }}>
              {instrucciones}
            </p>
          )}
        </div>
      </div>
    );
  }

  // Handle tagVencido state (tag expired)
  if (tagVencido) {
    return (
      <div style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #FFF9E6 0%, #FFFFFF 100%)",
        padding: "var(--space-4)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}>
        <div style={{
          backgroundColor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(20px)",
          borderRadius: "var(--radius-2xl)",
          boxShadow: "0 12px 40px rgba(0, 0, 0, 0.08)",
          overflow: "hidden",
          maxWidth: "500px",
          padding: "var(--space-5)",
          textAlign: "center"
        }}>
          <div style={{
            width: "72px",
            height: "72px",
            margin: "0 auto var(--space-3)",
            background: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
            borderRadius: "var(--radius-full)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 8px 24px rgba(245, 158, 11, 0.25)"
          }}>
            <i className="bi bi-clock-history"
               style={{ fontSize: '40px', color: 'white' }}></i>
          </div>
          <h5 style={{
            fontSize: 'var(--font-size-xl)',
            fontWeight: 'var(--font-weight-bold)',
            marginBottom: 'var(--space-2)',
            color: 'var(--gray-900)',
            letterSpacing: '-0.02em'
          }}>
            {t("es", "tagVencido")}
          </h5>
          {folio && (
            <p style={{
              fontSize: 'var(--font-size-sm)',
              color: '#d97706',
              fontWeight: 'var(--font-weight-semibold)',
              marginBottom: 'var(--space-2)'
            }}>
              Folio: {folio}
            </p>
          )}
          <p style={{
            fontSize: 'var(--font-size-sm)',
            color: 'var(--gray-600)',
            marginBottom: 'var(--space-3)',
            lineHeight: 'var(--line-height-relaxed)'
          }}>
            {mensajePublico || t("es", "tagVencidoMensaje")}
          </p>
          {instrucciones && (
            <p style={{
              fontSize: 'var(--font-size-xs)',
              color: 'var(--gray-500)',
              marginBottom: 0,
              lineHeight: 'var(--line-height-relaxed)',
              fontStyle: 'italic'
            }}>
              {instrucciones}
            </p>
          )}
        </div>
      </div>
    );
  }

  if (!objeto) {
    return null;
  }

  const langUI = objeto?.idiomaRecuperacion || propietario?.idiomaPreferido || "es";
  const mensajeInfo = getMensajePersonalizado(objeto, propietario, langUI);

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(135deg, #FFF9E6 0%, #FFFFFF 100%)",
      paddingTop: "56px",
      position: "relative"
    }}>
      
      {/* Patrón de fondo decorativo */}
      <div style={{
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        height: "250px",
        background: "radial-gradient(circle at 30% 20%, rgba(248, 215, 117, 0.08) 0%, transparent 50%), radial-gradient(circle at 70% 60%, rgba(248, 215, 117, 0.04) 0%, transparent 50%)",
        pointerEvents: "none",
        zIndex: 0
      }}></div>
      
      {/* HEADER STICKY */}
      <header style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        height: "56px",
        backgroundColor: "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(10px)",
        WebkitBackdropFilter: "blur(10px)",
        borderBottom: `1px solid rgba(229, 193, 98, 0.2)`,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 12px rgba(0, 0, 0, 0.04)"
      }}>
        <div style={{
          display: "flex",
          alignItems: "center",
          gap: "var(--space-2)"
        }}>
          <span style={{
            fontSize: "var(--font-size-lg)",
            fontWeight: "var(--font-weight-bold)",
            background: "linear-gradient(135deg, #f8d775 0%, #e5c162 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text",
            letterSpacing: "-0.02em"
          }}>
            LemmonTags
          </span>
        </div>
      </header>

      {/* CONTENIDO PRINCIPAL - Compactado */}
      <main style={{
        padding: "var(--space-2)",
        paddingBottom: "var(--space-3)",
        position: "relative",
        zIndex: 1
      }}>
        
        {/* Estado activo - noActivado y tagVencido ya se manejan arriba */}
          <div style={{ maxWidth: "600px", margin: "0 auto" }}>
            
            {/* MENSAJE EDUCATIVO DESTACADO - Compactado */}
            <div style={{
              backgroundColor: "rgba(255, 255, 255, 0.95)",
              backdropFilter: "blur(20px)",
              borderRadius: "var(--radius-lg)",
              padding: "var(--space-2) var(--space-3)",
              marginBottom: "var(--space-2)",
              border: "2px solid #f8d775",
              boxShadow: "0 4px 12px rgba(248, 215, 117, 0.15)",
              textAlign: "center"
            }}>
              <p style={{
                fontSize: "var(--font-size-xs)",
                fontWeight: "var(--font-weight-semibold)",
                color: "var(--gray-900)",
                lineHeight: "1.4",
                marginBottom: "var(--space-1)"
              }} dangerouslySetInnerHTML={{ __html: t(langUI, 'mensajeEducativo1') }} />
              <p style={{
                fontSize: "var(--font-size-xs)",
                color: "var(--gray-700)",
                lineHeight: "1.4",
                marginBottom: "var(--space-1)"
              }} dangerouslySetInnerHTML={{ __html: t(langUI, 'mensajeEducativo2') }} />
              <p style={{
                fontSize: "var(--font-size-xs)",
                color: "#d97706",
                fontWeight: "var(--font-weight-semibold)",
                marginBottom: 0
              }}>
                {t(langUI, 'mensajeEducativo3')}
              </p>
            </div>

            {/* Card principal del objeto */}
            <div style={{
              backgroundColor: "rgba(255, 255, 255, 0.9)",
              backdropFilter: "blur(20px)",
              borderRadius: "var(--radius-xl)",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.06)",
              overflow: "hidden",
              border: "1px solid rgba(255, 255, 255, 0.8)"
            }}>
              
              {/* Banda decorativa superior */}
              <div style={{
                height: "6px",
                background: `linear-gradient(90deg, ${mensajeInfo.color} 0%, ${mensajeInfo.color}dd 100%)`
              }}></div>
              
              {/* Imagen del objeto - compactada (solo si NO está extraviado) */}
              {!objeto.extraviado && (
              <div style={{
                display: "flex",
                justifyContent: "center",
                padding: "var(--space-3) var(--space-2) var(--space-2)",
                position: "relative"
              }}>
                <div style={{
                  position: "relative",
                  transition: "transform 0.3s ease"
                }}>
                  <div style={{
                    position: "absolute",
                    inset: "-12px",
                    background: `radial-gradient(circle, ${mensajeInfo.color}15 0%, transparent 70%)`,
                    borderRadius: "var(--radius-full)",
                    filter: "blur(12px)",
                    zIndex: 0
                  }}></div>

                  {/* Si hay foto, mostrarla. Si no, mostrar placeholder con icono según tipo */}
                  {objeto.fotoUrl ? (
                    <img
                      src={objeto.fotoUrl}
                      alt={t(langUI, "altImagenObjeto")}
                      style={{
                        width: "120px",
                        height: "120px",
                        borderRadius: "var(--radius-lg)",
                        objectFit: "cover",
                        boxShadow: "0 8px 20px rgba(0, 0, 0, 0.1)",
                        border: "4px solid white",
                        position: "relative",
                        zIndex: 1
                      }}
                    />
                  ) : (
                    <div style={{
                      width: "120px",
                      height: "120px",
                      borderRadius: "var(--radius-lg)",
                      background: "linear-gradient(135deg, #F8FAFC 0%, #E2E8F0 100%)",
                      boxShadow: "0 8px 20px rgba(0, 0, 0, 0.06)",
                      border: "4px solid white",
                      position: "relative",
                      zIndex: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "48px"
                    }}>
                      {objeto.tipo === 'mascota' && '🐕'}
                      {objeto.tipo === 'llavero' && '🔑'}
                      {objeto.tipo === 'coleccionable' && '🏆'}
                      {objeto.tipo === 'persona' && '👤'}
                      {!['mascota', 'llavero', 'coleccionable', 'persona'].includes(objeto.tipo) && '📦'}
                    </div>
                  )}
                  
                  {/* Badge del tipo */}
                  <div style={{
                    position: "absolute",
                    bottom: "-14px",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 2,
                    animation: "slideUp 0.5s ease-out"
                  }}>
                    {objeto.tipo === 'mascota' && (
                      <span style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "var(--space-1)",
                        fontSize: 'var(--font-size-xs)',
                        fontWeight: "var(--font-weight-bold)",
                        padding: 'var(--space-1) var(--space-3)',
                        background: 'var(--gradient-feature)',
                        color: 'white',
                        borderRadius: "var(--radius-full)",
                        boxShadow: '0 6px 16px rgba(51, 65, 85, 0.25), 0 0 0 3px white',
                        letterSpacing: '0.01em'
                      }}>
                        <i className="bi bi-heart-fill" style={{ fontSize: "11px" }}></i>Mascota
                      </span>
                    )}
                    {objeto.tipo === 'llavero' && (
                      <span style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "var(--space-1)",
                        fontSize: 'var(--font-size-xs)',
                        fontWeight: "var(--font-weight-bold)",
                        padding: 'var(--space-1) var(--space-3)',
                        background: 'linear-gradient(135deg, #64748B 0%, #475569 100%)',
                        color: 'white',
                        borderRadius: "var(--radius-full)",
                        boxShadow: '0 6px 16px rgba(100, 116, 139, 0.25), 0 0 0 3px white',
                        letterSpacing: '0.01em'
                      }}>
                        <i className="bi bi-key-fill" style={{ fontSize: "11px" }}></i>Llavero
                      </span>
                    )}
                    {/* Badge de Coleccionable removido - no es necesario mostrarlo de forma tan prominente */}
                  </div>
                </div>
              </div>
              )}

              {/* Contenido - compactado */}
              <div style={{ padding: "var(--space-2)" }}>

                {/* SOLO PLANTILLA HTML */}
                {contenidoHTML ? (
                  <div
                    dangerouslySetInnerHTML={{ __html: contenidoHTML }}
                    style={{
                      marginBottom: "var(--space-2)",
                      fontSize: 'var(--font-size-xs)',
                      color: 'var(--gray-800)',
                      lineHeight: '1.5'
                    }}
                  />
                ) : (
                  <div style={{
                    marginBottom: "var(--space-2)",
                    fontSize: 'var(--font-size-xs)',
                    color: 'var(--gray-700)',
                    lineHeight: '1.5',
                    textAlign: 'center'
                  }}>
                    <p style={{ marginBottom: 'var(--space-1)', textAlign: 'center' }}>
                      Este {objeto.tipo} pertenece a <strong>{getPrimerNombre(propietario?.nombre)}</strong>.
                    </p>
                    <p style={{ marginBottom: 0, textAlign: 'center', color: 'var(--gray-600)' }}>
                      Si lo encontraste, contáctalo para coordinar la devolución.
                    </p>
                  </div>
                )}

                {/* SECCIÓN DE CONTACTO - Solo si NO está perdido */}
                {!objeto.extraviado && propietario && (
                  <div style={{ marginBottom: "var(--space-2)" }}>

                    {/* OPCIÓN PRINCIPAL: WhatsApp */}
                    {propietario.telefono && (
                      <div style={{ marginBottom: "var(--space-2)" }}>
                        <a 
                          className="btn btn-success w-100"
                          href={`https://wa.me/52${propietario.telefono}?text=${encodeURIComponent(getWhatsAppText())}`}
                          target="_blank"
                          rel="noreferrer"
                          style={{
                            fontSize: 'var(--font-size-sm)',
                            fontWeight: 'var(--font-weight-bold)',
                            padding: 'var(--space-2)',
                            borderRadius: 'var(--radius-md)',
                            background: 'linear-gradient(135deg, #25D366 0%, #128C7E 100%)',
                            border: 'none',
                            boxShadow: '0 4px 12px rgba(37, 211, 102, 0.2)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            gap: 'var(--space-1)',
                            textDecoration: 'none',
                            color: 'white'
                          }}
                        >
                          <i className="bi bi-whatsapp" style={{ fontSize: "16px" }}></i>
                          {t(langUI, 'contactarPor', { nombreProp: getPrimerNombre(propietario?.nombre) })}
                        </a>

                        {/* Teléfono visible debajo */}
                        <p style={{
                          textAlign: 'center',
                          fontSize: 'var(--font-size-xs)',
                          color: 'var(--gray-500)',
                          marginTop: 'var(--space-1)',
                          marginBottom: 0
                        }}>
                          <i className="bi bi-telephone" style={{ marginRight: '4px' }}></i>
                          {propietario.telefono}
                        </p>
                      </div>
                    )}

                    {/* Separador */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 'var(--space-1)',
                      marginBottom: 'var(--space-2)'
                    }}>
                      <div style={{ flex: 1, height: '1px', background: 'var(--gray-300)' }}></div>
                      <span style={{ 
                        fontSize: 'var(--font-size-xs)', 
                        color: 'var(--gray-500)',
                        fontWeight: 'var(--font-weight-medium)'
                      }}>
                        {propietario.telefono ? t(langUI, 'noPuedesLlamar') : t(langUI, 'contactar')}
                      </span>
                      <div style={{ flex: 1, height: '1px', background: 'var(--gray-300)' }}></div>
                    </div>
                    
                    {/* ✅ OPCIÓN SECUNDARIA: Dejar mensaje */}
                    <button
                      onClick={async () => {
                        const lang = objeto?.idiomaRecuperacion || propietario?.idiomaPreferido || "es";

                        // Mostrar modal y capturar mensaje + teléfono
                        const resultado = await mostrarModalAviso(lang, objeto, propietario);
                        
                        // Si canceló, no hacer nada
                        if (resultado === null) {
                          return;
                        }
                        
                        // Determinar template
                        let templateKey = "";
                        if (objeto.tipo === "mascota") {
                          templateKey = "mascotaEncontrada";
                        } else if (objeto.tipo === "llavero") {
                          templateKey = "llaveroEncontrado";
                        } else {
                          templateKey = "llaveroEncontrado"; // fallback
                        }
                        
                        // Preparar contexto para el email
                        const context = {
                          nombreMascota: getNombreSegunTipo(objeto),
                          nombreObjeto: getNombreSegunTipo(objeto),
                          nombre: getNombreSegunTipo(objeto),
                          nombrePropietario: getPrimerNombre(propietario.nombre) || "Propietario",
                          tipoObjeto: objeto.tipo,
                          mensajeFinder: resultado.mensaje || "", // ✅ NUEVO: Mensaje del encontrador
                          telefonoFinder: resultado.telefono || "",
                          googleMapsLink: ""
                        };
                        
                        // Enviar correo
                        const exito = await enviarCorreoAlPropietario(t(lang, templateKey), context);
                        
                        if (exito) {
                          mostrarModalGracias(lang, getPrimerNombre(propietario.nombre));
                        } else {
                          mostrarConfirmacion(
                            lang === 'en' ? "There was an error sending the notification" : "Hubo un error al enviar la notificación",
                            false
                          );
                        }
                      }}
                      style={{
                        width: '100%',
                        fontSize: 'var(--font-size-xs)',
                        fontWeight: 'var(--font-weight-semibold)',
                        padding: 'var(--space-2)',
                        borderRadius: 'var(--radius-md)',
                        background: 'white',
                        border: '1px solid var(--gray-300)',
                        color: 'var(--gray-700)',
                        transition: 'all 0.3s ease',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 'var(--space-2)',
                        cursor: 'pointer'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.borderColor = '#f8d775';
                        e.currentTarget.style.background = '#FFFBEB';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.borderColor = 'var(--gray-300)';
                        e.currentTarget.style.background = 'white';
                      }}
                    >
                      <i className="bi bi-pencil-square" style={{ fontSize: "16px" }}></i>
                      {t(langUI, 'dejarUnMensaje')}
                    </button>
                  </div>
                )}

                {/* Info específica (raza, señas, alergias) */}
                {!contenidoHTML && objeto.tipo === 'mascota' && (objeto.raza || objeto.senasParticulares || objeto.alergias) && (
                  <div style={{ marginBottom: "var(--space-3)" }}>
                    <div style={{
                      background: "linear-gradient(135deg, #F8FAFC 0%, #F1F5F9 100%)",
                      padding: "var(--space-2)",
                      borderRadius: "var(--radius-md)",
                      fontSize: "var(--font-size-xs)",
                      border: "1px solid var(--gray-200)"
                    }}>
                      {objeto.raza && (
                        <p style={{
                          marginBottom: 'var(--space-1)',
                          display: "flex",
                          alignItems: "center",
                          gap: "var(--space-1)"
                        }}>
                          <strong>{t(langUI, 'raza')}:</strong> {objeto.raza}
                        </p>
                      )}
                      {objeto.senasParticulares && (
                        <p style={{
                          marginBottom: objeto.alergias ? 'var(--space-1)' : 0,
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "var(--space-1)"
                        }}>
                          <strong>{t(langUI, 'senas')}:</strong> {objeto.senasParticulares}
                        </p>
                      )}
                      {objeto.alergias && (
                        <p style={{
                          marginBottom: 0,
                          display: "flex",
                          alignItems: "flex-start",
                          gap: "var(--space-1)"
                        }}>
                          <strong>{t(langUI, 'alergias')}:</strong> {objeto.alergias}
                        </p>
                      )}
                    </div>
                  </div>
                )}

                {/* =============================================
                    PANTALLA 2: Contacto del dueño (rediseñada)
                    Solo visible cuando está perdido
                   ============================================= */}
                {objeto.extraviado && (
                  <div style={{
                    background: DS.colors.bgSurface,
                    padding: '20px',
                    borderRadius: DS.radius.lg,
                    marginBottom: '16px',
                    border: `1px solid ${DS.colors.borderSoft}`,
                    fontFamily: DS.fonts.family
                  }}>
                    {/* Indicador de pasos */}
                    <div style={{
                      display: 'flex',
                      justifyContent: 'center',
                      gap: '8px',
                      marginBottom: '16px'
                    }}>
                      <span style={{
                        width: '8px', height: '8px',
                        borderRadius: '50%',
                        background: DS.colors.borderSoft
                      }}></span>
                      <span style={{
                        width: '8px', height: '8px',
                        borderRadius: '50%',
                        background: DS.colors.successIcon
                      }}></span>
                    </div>

                    {/* Estado */}
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px',
                      marginBottom: '16px'
                    }}>
                      <span style={{ color: DS.colors.successIcon, fontSize: '18px' }}>✓</span>
                      <span style={{
                        color: DS.colors.textPrimary,
                        fontSize: '15px',
                        fontWeight: '600'
                      }}>
                        {objeto.tipo === 'mascota'
                          ? (langUI === 'en' ? 'Pet found' : 'Mascota encontrada')
                          : (langUI === 'en' ? 'Item found' : 'Objeto encontrado')}
                      </span>
                    </div>

                    {/* Identidad con foto */}
                    <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                      {objeto.fotoUrl && (
                        <img
                          src={objeto.fotoUrl}
                          alt={getNombreSegunTipo(objeto)}
                          style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: DS.radius.md,
                            objectFit: 'cover',
                            marginBottom: '12px',
                            border: `2px solid ${DS.colors.borderSoft}`
                          }}
                        />
                      )}
                      <p style={{
                        color: DS.colors.textPrimary,
                        fontSize: '16px',
                        fontWeight: '600',
                        margin: '0 0 4px'
                      }}>
                        {getNombreSegunTipo(objeto)}
                      </p>
                      {propietario && (
                        <p style={{
                          color: DS.colors.textSecondary,
                          fontSize: '14px',
                          margin: 0
                        }}>
                          {langUI === 'en' ? 'Belongs to' : 'Pertenece a'} {getPrimerNombre(propietario.nombre)}
                        </p>
                      )}
                    </div>

                    {/* Información de contacto */}
                    {propietario && (
                      <div style={{
                        background: DS.colors.bgBase,
                        padding: '16px',
                        borderRadius: DS.radius.md,
                        border: `1px solid ${DS.colors.borderSoft}`,
                        marginBottom: '16px'
                      }}>
                        <p style={{
                          color: DS.colors.textSecondary,
                          fontSize: '13px',
                          margin: '0 0 4px'
                        }}>
                          {langUI === 'en' ? 'Owner' : 'Propietario'}
                        </p>
                        <p style={{
                          color: DS.colors.textPrimary,
                          fontSize: '15px',
                          fontWeight: '600',
                          margin: '0 0 8px'
                        }}>
                          {getPrimerNombre(propietario.nombre)}
                        </p>
                        {propietario.telefono && (
                          <p style={{
                            color: DS.colors.textSecondary,
                            fontSize: '14px',
                            margin: 0,
                            display: 'flex',
                            alignItems: 'center',
                            gap: '6px'
                          }}>
                            <i className="bi bi-telephone" style={{ fontSize: '12px' }}></i>
                            {propietario.telefono}
                          </p>
                        )}
                      </div>
                    )}

                    {/* Recompensa */}
                    {objeto.ofrecerRecompensa && objeto.recompensa && (
                      <div style={{
                        background: DS.colors.highlightReward,
                        padding: '14px',
                        borderRadius: DS.radius.md,
                        border: `1px solid ${DS.colors.highlightRewardBorder}`,
                        marginBottom: '16px',
                        textAlign: 'center'
                      }}>
                        <p style={{
                          color: DS.colors.textPrimary,
                          fontSize: '13px',
                          fontWeight: '600',
                          margin: '0 0 4px'
                        }}>
                          {langUI === 'en'
                            ? `${getPrimerNombre(propietario?.nombre)} offers a reward`
                            : `${getPrimerNombre(propietario?.nombre)} ofrece una recompensa`}
                        </p>
                        <p style={{
                          color: DS.colors.textPrimary,
                          fontSize: '24px',
                          fontWeight: '700',
                          margin: 0
                        }}>
                          ${objeto.recompensa} MXN
                        </p>
                      </div>
                    )}

                    {/* Botón WhatsApp */}
                    {propietario?.telefono && (
                      <a
                        href={`https://wa.me/52${propietario.telefono}?text=${encodeURIComponent(getWhatsAppText())}`}
                        target="_blank"
                        rel="noreferrer"
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          gap: '10px',
                          width: '100%',
                          padding: '14px 20px',
                          background: DS.colors.whatsapp,
                          color: 'white',
                          border: 'none',
                          borderRadius: DS.radius.md,
                          fontSize: '15px',
                          fontWeight: '600',
                          textDecoration: 'none',
                          marginBottom: '12px'
                        }}
                      >
                        <i className="bi bi-whatsapp" style={{ fontSize: '20px' }}></i>
                        {langUI === 'en' ? 'Contact via WhatsApp' : 'Contactar por WhatsApp'}
                      </a>
                    )}

                    {/* Mensaje de privacidad */}
                    <p style={{
                      color: '#9CA3AF',
                      fontSize: '12px',
                      textAlign: 'center',
                      margin: '0 0 12px',
                      lineHeight: '1.4'
                    }}>
                      {langUI === 'en'
                        ? 'Your information is private. You are only helping to return this item.'
                        : 'Tu información es privada. Solo estás ayudando a regresar este objeto.'}
                    </p>

                    {/* Branding */}
                    <div style={{
                      textAlign: 'center',
                      paddingTop: '12px',
                      borderTop: `1px solid ${DS.colors.borderSoft}`
                    }}>
                      <span style={{
                        color: '#D1D5DB',
                        fontSize: '12px',
                        fontWeight: '500'
                      }}>LemmonTags</span>
                      <br />
                      <span style={{
                        color: '#E5E7EB',
                        fontSize: '11px'
                      }}>
                        {langUI === 'en' ? 'Helping recover since 2026' : 'Ayudando a recuperar desde 2026'}
                      </span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

        {/* Link sutil de verificación de autenticidad - antes del footer */}
        {objeto?.numeroSerie && (
          <div style={{
            textAlign: "center",
            marginTop: "var(--space-3)",
            paddingTop: "var(--space-3)",
            borderTop: "1px solid var(--gray-200)"
          }}>
            <a
              href={`/validacion?serial=${encodeURIComponent(objeto.numeroSerie)}`}
              style={{
                fontSize: "var(--font-size-xs)",
                color: "var(--gray-500)",
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
                gap: "4px"
              }}
            >
              <i className="bi bi-shield-check" style={{ fontSize: "12px" }}></i>
              {t(langUI, 'verificarAutenticidad')}
            </a>
          </div>
        )}

        {/* FOOTER */}
        <footer style={{
          marginTop: "var(--space-6)",
          padding: "var(--space-4) var(--space-3)",
          textAlign: "center"
        }}>
          <div style={{
            margin: "0 auto var(--space-2)",
            fontSize: "var(--font-size-lg)",
            fontWeight: "var(--font-weight-bold)",
            background: "linear-gradient(135deg, #f8d775 0%, #e5c162 100%)",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            backgroundClip: "text"
          }}>
            LemmonTags
          </div>
          <p style={{
            fontSize: 'var(--font-size-sm)',
            color: 'var(--gray-700)',
            marginBottom: 'var(--space-1)',
            fontWeight: 'var(--font-weight-medium)'
          }}>
            <a
              href="https://www.lemmontags.com"
              target="_blank"
              rel="noreferrer"
              style={{
                background: 'linear-gradient(135deg, #f8d775 0%, #e5c162 100%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                backgroundClip: 'text',
                fontWeight: 'var(--font-weight-bold)',
                textDecoration: 'none'
              }}
            >
              {t(langUI, "visitarLemmon")}
            </a>
          </p>
          <p style={{
            fontSize: '11px',
            color: 'var(--gray-500)',
            marginBottom: 0
          }}>
            {t(langUI, "todosDerechos")}
          </p>
        </footer>
      </main>
      
      {/* Animaciones CSS */}
      <style>{`
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(8px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
        
        @keyframes bounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-8px); }
        }
        
        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }
      `}</style>
    </div>
  );

}

const mostrarModalGracias = (lang, nombrePropietario) => {
  const modalHTML = `
    <div class="modal fade" id="graciasModal" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" style="margin: var(--space-3); max-width: 380px;">
        <div class="modal-content" style="border-radius: var(--radius-xl); overflow: hidden; border: none;">

          <!-- Header compacto -->
          <div style="
            background: linear-gradient(135deg, #10b981 0%, #059669 100%);
            padding: var(--space-3);
            text-align: center;
            position: relative;
          ">
            <div style="
              font-size: 48px;
              margin-bottom: var(--space-1);
              animation: bounce 1.5s ease-in-out 2;
            ">
              🎉
            </div>
            <h5 style="
              color: white;
              font-size: var(--font-size-xl);
              font-weight: var(--font-weight-bold);
              margin: 0;
              text-shadow: 0 2px 4px rgba(0,0,0,0.2);
            ">
              ${t(lang, 'graciasTitle')}
            </h5>
          </div>

          <!-- Body compacto -->
          <div style="padding: var(--space-3);">

            <!-- Mensaje principal -->
            <div style="text-align: center; margin-bottom: var(--space-3);">
              <p style="
                font-size: var(--font-size-sm);
                color: var(--gray-900);
                line-height: var(--line-height-relaxed);
                margin-bottom: var(--space-2);
                font-weight: var(--font-weight-semibold);
              ">
                <strong style="color: #10b981;">${nombrePropietario}</strong> ${lang === 'en' ? 'will receive your message and will contact you soon.' : 'recibirá tu mensaje y se comunicará contigo muy pronto.'}
              </p>
            </div>

            <!-- Sección de impacto compacta -->
            <div style="
              background: linear-gradient(135deg, #FEF3C7 0%, #FDE68A 100%);
              padding: var(--space-3);
              border-radius: var(--radius-lg);
              border: 2px solid #FDE047;
              text-align: center;
              margin-bottom: var(--space-3);
            ">
              <div style="font-size: 32px; margin-bottom: var(--space-1);">⭐</div>
              <p style="
                font-size: var(--font-size-sm);
                color: #92400E;
                font-weight: var(--font-weight-bold);
                margin-bottom: var(--space-1);
                line-height: 1.3;
              ">
                ${t(lang, 'graciasComunidad')}
              </p>
              <p style="
                font-size: var(--font-size-xs);
                color: #78350F;
                margin: 0;
                line-height: var(--line-height-relaxed);
              ">
                ${t(lang, 'graciasHonestidad')} 💛
              </p>
            </div>
            
            <!-- Stats compactos -->
            <div style="
              display: flex;
              justify-content: space-around;
              gap: var(--space-2);
              margin-bottom: var(--space-2);
            ">
              <div style="text-align: center;">
                <div style="font-size: 24px; color: #10b981;">🍋</div>
                <p style="
                  font-size: 10px;
                  color: var(--gray-600);
                  margin: 2px 0 0 0;
                ">
                  LemmonTags
                </p>
              </div>
              
              <div style="text-align: center;">
                <div style="font-size: 24px; color: #10b981;">🤝</div>
                <p style="
                  font-size: 10px;
                  color: var(--gray-600);
                  margin: 2px 0 0 0;
                ">
                  Comunidad
                </p>
              </div>
              
              <div style="text-align: center;">
                <div style="font-size: 24px; color: #10b981;">💚</div>
                <p style="
                  font-size: 10px;
                  color: var(--gray-600);
                  margin: 2px 0 0 0;
                ">
                  Ayuda
                </p>
              </div>
            </div>
          </div>
          
          <!-- Footer compacto -->
          <div style="
            padding: var(--space-3);
            background: var(--gray-50);
          ">
            <button 
              type="button" 
              class="btn btn-success w-100" 
              id="cerrarGracias"
              style="
                font-size: var(--font-size-sm);
                font-weight: var(--font-weight-bold);
                padding: var(--space-2);
                border-radius: var(--radius-lg);
                background: linear-gradient(135deg, #10b981 0%, #059669 100%);
                border: none;
                box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
                transition: all 0.3s ease;
                color: white;
              "
            >
              ✓ ${t(lang, 'entendido')}
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <style>
      @keyframes bounce {
        0%, 100% { transform: scale(1) translateY(0); }
        50% { transform: scale(1.1) translateY(-8px); }
      }
      
      #graciasModal .modal-dialog {
        max-height: 90vh;
      }
      
      #graciasModal .modal-content {
        max-height: 90vh;
        overflow-y: auto;
      }
    </style>
  `;

  document.body.insertAdjacentHTML("beforeend", modalHTML);

  if (typeof window.bootstrap !== "undefined") {
    const el = document.getElementById("graciasModal");
    const modal = new window.bootstrap.Modal(el);

    const btnCerrar = document.getElementById("cerrarGracias");
    btnCerrar.addEventListener("mouseenter", () => {
      btnCerrar.style.transform = "translateY(-2px)";
      btnCerrar.style.boxShadow = "0 6px 16px rgba(16, 185, 129, 0.4)";
    });
    btnCerrar.addEventListener("mouseleave", () => {
      btnCerrar.style.transform = "translateY(0)";
      btnCerrar.style.boxShadow = "0 4px 12px rgba(16, 185, 129, 0.3)";
    });

    btnCerrar.onclick = () => {
      modal.hide();
      setTimeout(() => el.remove(), 300);
    };

    modal.show();
  } else {
    const el = document.getElementById("graciasModal");
    if (el) el.remove();
  }
};